// extracted by mini-css-extract-plugin
export var noSpinners = "_sc-6";
export var percentageInput = "_sc-7";
export var variantColor1 = "_sc-0";
export var variantColor2 = "_sc-1";
export var variantColor3 = "_sc-2";
export var variantColor4 = "_sc-3";
export var variantColor5 = "_sc-4";
export var variantColor6 = "_sc-5";